import { Routes as CoreRoutes } from 'core/pages'
import ShippingReading from './Shipping/ShippingReading'
import ShippingStart from './Shipping/ShippingStart'

///////////////////////////////////////////////////////////////////////////////
// Custom & core overrides, change only this!
///////////////////////////////////////////////////////////////////////////////

const CustomDirectRoutes = {}
const CustomRoutes = {
  '/shipping/:opCode': { component: ShippingStart },
  '/shipping/:opCode/reading': { component: ShippingReading }
}

///////////////////////////////////////////////////////////////////////////////

export const Routes = { ...CustomDirectRoutes, ...CoreRoutes, ...CustomRoutes }
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Routes = keyof typeof Routes
